import { useRef, useState, useEffect } from "react";

import { StyledPath } from "./Keyframes";
import { BASE_DURATION } from "./constants";

interface TreeProps {
  index: number;
}

function Tree({ index }: TreeProps) {
  const pathRef = useRef<SVGPathElement>(null);
  const [pathLength, setPathLength] = useState(0);

  const path = `M 0 -80
    Q 5 -75 0 -70
    Q -10 -65 0 -60
    Q 15 -55 0 -50
    Q -20 -45 0 -40
    Q 25 -35 0 -30
    Q -30 -25 0 -20
    Q 35 -15 0 -10
    Q -40 -5 0 0
    Q 45 5 0 10
    Q -50 15 0 20
    Q 55 25 0 30
    Q -60 35 0 40
    Q 65 45 0 50
    Q -70 55 0 60
    Q 75 65 0 70
    Q -80 75 0 80
    Q 85 85 0 90
    Q -90 95 0 100
    Q 95 105 0 110
    Q -100 115 0 120
    L 0 140
    L 20 140
    L -20 140`;

  useEffect(() => {
    if (pathRef.current) {
      setPathLength(pathRef.current.getTotalLength());
    }
  }, []);

  const pathProps = {
    pathLength,
    strokeDasharray: pathLength,
    strokeDashoffset: pathLength,
    strokeLinejoin: "round" as "round",
    strokeWidth: 2,
    strokeLinecap: "round" as "round",
    stroke: "url(#gradient)",
    d: path,
    fill: "none",
    duration: BASE_DURATION,
    delay: index * (BASE_DURATION * 0.6),
  };

  return (
    <svg height="100%" viewBox={"-52 -135 102 280"}>
      <StyledPath ref={pathRef} {...pathProps} />
    </svg>
  );
}

export default Tree;
